<ion-content>
	<div class="quickLogger-logo">
		<ion-img src="./../../../../assets/icon/quickLogger-logo.png" alt="QuickLogger logo"></ion-img>
	</div>
	<div class="content">
		<div class="progress-bar">
			<div class="back-button" (click)="goBack()"><ion-icon class="icon-Arrow-Left"></ion-icon></div>
			<ul>
				<li class="past"><span class="outer-circle"></span></li>
				<li class="past"><span class="outer-circle"></span></li>
				<li class="current"><span class="outer-circle"></span></li>
				<li><span class="outer-circle"></span></li>
			</ul>
		</div>

		<div class="helper-text">{{ helperText }}</div>

		<div class="form">
			<form
				[formGroup]="registrationForm"
				role="form"
				(ngSubmit)="onSubmit(registrationForm.value)"
				autocomplete="off"
			>
				<ion-item>
					<ion-input
						formControlName="fieldFormControl"
						class="password"
						[type]="showPassword ? 'text' : 'password'"
						placeholder="{{ 'registration.form.placeholder.password' | translate }}"
					></ion-input>
					<span
						class="icon"
						[ngClass]="{ 'no-show': !showPassword, show: showPassword }"
						(click)="toggleFieldTextType()"
					></span>
				</ion-item>
				<ion-item>
					<button type="submit" [ngClass]="{ disabled: !registrationForm.valid }">
						{{ 'registration.buttons.submit' | translate }}
					</button>
				</ion-item>
			</form>
		</div>
	</div>
	<div class="datamine-logo">
		<ion-img src="./../../../../assets/icon/datamine-logo.png" alt="Datamine logo"></ion-img>
	</div>
</ion-content>
